<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center" style="height: 80px">
      <vuestic-logo height="32"/>
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <va-card-content>
            <va-tabs v-model="tabIndex" center>
              <template #tabs>
                <va-tab name="login">登录</va-tab>

              </template>
            </va-tabs>

            <va-separator/>

            <div class="pa-3">
              <router-view/>
            </div>
          </va-card-content>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import VuesticLogo from "@/components/vuestic-logo-no-notice.vue";

export default {
  name: "AdminAuthLayout",
  components: {VuesticLogo},
  data() {
    return {
      selectedTabIndex: 0
    };
  },
  computed: {
    tabIndex: {
      set(tabName) {
        this.$router.push({name: tabName});
      },
      get() {
        return this.$route.name;
      }
    }
  }
};
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, var(--va-background), var(--va-white));

  &__card {
    width: 100%;
    max-width: 600px;
  }
}
</style>
